import { render, staticRenderFns } from "./Custom_reports.vue?vue&type=template&id=51d9076a&scoped=true"
import script from "./Custom_reports.vue?vue&type=script&lang=js"
export * from "./Custom_reports.vue?vue&type=script&lang=js"
import style0 from "./Custom_reports.vue?vue&type=style&index=0&id=51d9076a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d9076a",
  null
  
)

export default component.exports